// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 144 ? "fa3de7d5" : chunkId) + "." + {"57":"892ebaf37cc39a56","100":"a2fdbebbb620a00c","144":"61d066532dcedd06","352":"c05ee2951ba1c9af"}[chunkId] + ".js";
};